export default "__VITE_ASSET__DQSkGb8d__"